import { Skeleton } from "./skeleton";
import { cn } from "./utils";

interface ListSkeletonProps {
  rows?: number;
  twoLine?: boolean;
  className?: string;
}

/**
 * Placeholder rows for picker / list views while a query loads.
 * Mirrors the inline pattern in ChecklistPickerDrawer.
 */
function ListSkeleton({ rows = 5, twoLine = true, className }: ListSkeletonProps) {
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="flex flex-col items-start gap-1.5 min-h-9 px-3 py-2"
        >
          <Skeleton className="h-5 w-2/5" />
          {twoLine && <Skeleton className="h-4 w-3/5" />}
        </div>
      ))}
    </div>
  );
}

interface DetailSkeletonProps {
  rows?: number;
  className?: string;
}

/**
 * Header block plus a few field rows for detail / document / settings views.
 */
function DetailSkeleton({ rows = 5, className }: DetailSkeletonProps) {
  return (
    <div className={cn("flex flex-col gap-3 p-2", className)}>
      <Skeleton className="h-14 w-full rounded-xl" />
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-12 w-full rounded-xl" />
      ))}
    </div>
  );
}

interface FormSkeletonProps {
  fields?: number;
  className?: string;
}

/**
 * Labelled field placeholders for form / editor views.
 * Mirrors the inline pattern in FlightDrawer.
 */
function FormSkeleton({ fields = 5, className }: FormSkeletonProps) {
  return (
    <div className={cn("flex flex-col gap-4 p-2", className)}>
      {Array.from({ length: fields }).map((_, i) => (
        <div key={i} className="flex flex-col gap-1.5">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-12 w-full rounded-xl" />
        </div>
      ))}
    </div>
  );
}

export { ListSkeleton, DetailSkeleton, FormSkeleton };
